import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { Variables } from '../../base';

export const Header = styled.div`
    display: flex;
    align-items: center;
    background-color: ${Variables.ThemeLight.Background2};
    border-bottom: 1px solid ${Variables.Colors.n15};
    padding: 16px 24px;
`;

export const HeaderLabels = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    gap: 8px;
`;

export const HeaderTextBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const CreatedBy = styled.span`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.semibold};
    line-height: 1.4;
    color: ${Variables.Colors.n100};
`;

export const CreatedDate = styled.span`
    font-size: 14px;
    font-weight: ${Variables.FontWeight.regular};
    line-height: 1.4;
    color: ${Variables.Colors.n70};
`;

export const BackButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    margin-right: 12px;
    cursor: pointer;
    color: ${Variables.Colors.n50};
    transition: color 0.2s ease;

    &:hover {
        color: ${Variables.Colors.n70};
    }
`;

export const CloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    color: ${Variables.Colors.n50};
    transition: color 0.2s ease;

    &:hover {
        color: ${Variables.Colors.n70};
    }
`;

export const CloseIcon = styled(Icon)``;

export const BackIcon = styled(Icon)``;
